import { Capacitor } from '@capacitor/core'
import { PushNotifications } from '@capacitor/push-notifications'

export const NATIVE_HOME = 'worx:native-home'

/** Consume retained cold-start taps and warm taps, without reloading WKWebView. */
export function listenForNativeHome(onHome: () => void): () => void {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'ios') return () => undefined
  let active = true
  let remove: (() => Promise<void>) | undefined
  void PushNotifications.addListener('pushNotificationActionPerformed', ({ actionId, notification }) => {
    // Only the known application route is supported. Never navigate to a payload URL.
    if (active && actionId === 'tap' && notification.data?.target === '/') onHome()
  }).then((handle) => {
    if (!active) void handle.remove().catch(() => undefined)
    else remove = () => handle.remove()
  }).catch(() => undefined)
  return () => {
    active = false
    if (remove) void remove().catch(() => undefined)
  }
}
